<template>
  <div class="item">
    <div class="item__row">
      <h5 class="item__title">{{ hospital.name }}</h5>
      <p class="item__town">
        {{ hospital.address.zipCode }} {{ hospital.address.town }}
      </p>
      <div
        v-if="computedAdditionalServices.length"
        class="item__column-features"
      >
        <div v-for="tag in computedAdditionalServices" :key="tag.tagKey">
          <span v-if="tag.tagIcon" class="item__column-features-item">
            <dotcom-icon
              :name="tag.tagIcon"
              art="light"
              class="item__column-features-icon"
            />{{ tag.tagName }}
          </span>
        </div>
      </div>
    </div>
    <div class="item__button">
      <sanitas-button
        full-width-in-xs
        secondary
        @click="$emit('detailClick', hospital)"
      >
        {{ $t('listShowDetail') }}
      </sanitas-button>
    </div>
  </div>
</template>

<script>
import { useI36n } from '@jota-one/i36n/src/index.vue2'

import SanitasButton from '@/components/sanitas-components/SanitasButton'
import DotcomIcon from '@/modules/icon/Icon'

export default {
  name: 'Item',
  components: {
    DotcomIcon,
    SanitasButton,
  },
  props: {
    hospital: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { $label } = useI36n()

    return {
      $t: $label,
    }
  },
  computed: {
    computedAdditionalServices() {
      const ZUSATZLEISTUNGEN = 'ZUSATZLEISTUNGEN'
      const PRIORITYACCESS = 'PRIORITYACCESS'
      const ZWEITMEINUNG = 'ZWEITMEINUNG'
      const UEBERNACHTUNGSMOEGLICHKEIT = 'UEBERNACHTUNGSMOEGLICHKEIT'

      return (
        this.hospital.filters
          .find(obj => {
            return obj.groupKey === ZUSATZLEISTUNGEN
          })
          ?.tags.filter(obj =>
            [PRIORITYACCESS, ZWEITMEINUNG, UEBERNACHTUNGSMOEGLICHKEIT].includes(
              obj.tagKey,
            ),
          ) ?? []
      )
    },
  },
}
</script>

<style scoped>
.item {
  background-color: var(--c-primary-neutral-3);
  padding: var(--spacing-4);
  margin-bottom: var(--spacing-6);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.item__title {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: var(--spacing-2);
}

.item__town {
  font-size: 14px;
  line-height: 20px;
  color: var(--c-secondary-neutral-2);
  margin-bottom: var(--spacing-4);
}

.item__column-features {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-2) var(--spacing-8);
  flex-direction: column;
  margin-bottom: var(--spacing-2);
}

.item__button {
  display: flex;
  align-items: flex-end;
  flex: 1;
}

.item__column-features-icon {
  margin-right: var(--spacing-2);
  width: 24px;
}

.item__column-features-item {
  display: inline-block;
  font-size: 14px;
  color: var(--c-primary-neutral-1);
}

@media (--sm) {
  .item__button {
    flex: 0;
  }

  .item {
    flex-direction: row;
    margin-bottom: var(--spacing-4);
  }

  .item__column-features {
    flex-direction: row;
    margin-bottom: 0;
  }

  .item__column-features-icon {
    width: auto;
  }

  .item__title {
    font-size: 16px;
  }

  .item__town {
    font-size: 16px;
  }

  .item__column-features-item {
    font-size: 16px;
  }
}
</style>
